import { render, staticRenderFns } from "./propertyDetail.vue?vue&type=template&id=5213cffe&scoped=true"
import script from "./propertyDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./propertyDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./propertyDetail.vue?vue&type=style&index=0&id=5213cffe&prod&lang=css"
import style1 from "./propertyDetail.vue?vue&type=style&index=1&id=5213cffe&prod&scoped=true&lang=css"
import style2 from "./propertyDetail.vue?vue&type=style&index=2&id=5213cffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5213cffe",
  null
  
)

export default component.exports